'use client';

import CategoryCard from './CategoryCard';
import { Package, Smartphone, Wrench, Laptop, Tablet, Battery, Cable, Headphones, Settings, Server } from 'lucide-react';

export default function DiscoverMore() {
  const categories = [
    {
      id: 1,
      title: 'Téléphones',
      description: 'Occasion et neuf - Toutes marques',
      icon: Smartphone,
      href: '/products?category=SMARTPHONE',
    },
    {
      id: 2,
      title: 'Ordinateurs',
      description: 'Portables et fixes neufs',
      icon: Laptop,
      href: '/products?category=LAPTOP',
    },
    {
      id: 3,
      title: 'Tablettes',
      description: 'iPad et tablettes Android neuves',
      icon: Tablet,
      href: '/products?category=TABLET',
    },
    {
      id: 4,
      title: 'NAS & Serveurs',
      description: 'Solutions de stockage professionnelles',
      icon: Server,
      href: '/products?category=NAS',
    },
    {
      id: 5,
      title: 'Accessoires',
      description: 'Batteries externes, câbles, chargeurs, écouteurs',
      icon: Battery,
      href: '/products?category=ACCESSORIES',
    },
    {
      id: 6,
      title: 'Coques & Protection',
      description: 'Coques, verres trempés et protections',
      icon: Package,
      href: '/products?category=ACCESSORY_CASE',
    },
    {
      id: 7,
      title: 'Pièces Détachées',
      description: 'Écrans et batteries pour réparation',
      icon: Settings,
      href: '/products?category=SPARE_PARTS',
    },
    {
      id: 8,
      title: 'Services Réparation',
      description: 'Écran, batterie, dégâts des eaux - 15min',
      icon: Wrench,
      href: '/services',
    },
  ];

  return (
    <section id="discover-more" className="py-12 sm:py-16 lg:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

        <div className="text-center mb-8 sm:mb-12 lg:mb-16 fade-in">
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-3 sm:mb-4">
            Découvrez plus
          </h2>
          <p className="text-base sm:text-lg text-gray-600">
            Explorez nos autres services et produits complémentaires
          </p>
        </div>


        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 sm:gap-6">
          {categories.map((category, idx) => (
            <div key={category.id} style={{ animationDelay: `${idx * 0.15}s` }} className="stagger-item h-full">
              <CategoryCard
                title={category.title}
                description={category.description}
                icon={category.icon}
                href={category.href}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
